import React from "react";
import { useDisconnect, useNetwork } from "wagmi";

import { Button, Flex, P, Semi, Spacer } from "../base";
import { useChainId } from "../modules/hooks";
import { BadNetwork } from "./Icons";
import Modal from "./Modal";

const realChainId = (chainId) => {
  switch (chainId) {
    case "1":
      return "the Ethereum Mainnet";
    case "3":
      return "the Ropsten Testnet";
    case "4":
      return "the Rinkeby Testnet";
    case "42":
      return "the Kovan Testnet";
    case "5":
      return "the Goerli Testnet";
    default:
      return "this Ethereum network";
  }
};

const useChainName = () => {
  const chainId = useChainId();

  return realChainId(chainId);
};

const BadNetworkModal = () => {
  const { disconnect } = useDisconnect();
  const { chain } = useNetwork();
  const isUnsupportedNetwork = chain?.unsupported;

  const chainName = useChainName();

  return isUnsupportedNetwork ? (
    <Modal
      icon={BadNetwork}
      title={`Capacity isn’t available on ${chainName}.`}
    >
      <P>
        Please ensure that your wallet is connected to the{" "}
        <Semi>Sepolia Testnet</Semi> and try again.
      </P>
      <Spacer size={48} />
      <Flex center>
        <Button title="Deactivate" onClick={() => disconnect()} />
      </Flex>
    </Modal>
  ) : null;
};

export default BadNetworkModal;
